import React, { Component } from 'react';
import * as defaultConst from '../../../../../../utils/clientConstant';
// import commonUtil from '../../../../../../utils/commonUtil';

export default class SuspendedEventBanner extends Component {
  constructor(props) {
    super(props);
    this.htmlContent = '';
  }

  // componentDidMount() {
    // const htmlContainer = document.querySelector('.mainBanner');
    // if (htmlContainer) {
    //   const restURL = htmlContainer.getAttribute('style');
    //   const fullURL = commonUtil.getAssetURL() + restURL;
    //   htmlContainer.setAttribute('style', 'background-image: url(' + fullURL + ')');
    // }
  // }
  render() {
    if (this.props.suspendedData && this.props.suspendedData.targeterContents) {
      if (this.props.eventStatus !== defaultConst.eventStatus.ACTIVE || (this.props.eventStatus === defaultConst.eventStatus.ACTIVE && this.props.showBanner)) {
        this.htmlContent = (<div dangerouslySetInnerHTML={{ __html: this.props.suspendedData.targeterContents[0].data }} />);
      }
    }
    return (
      <React.Fragment>
        {this.htmlContent}
      </React.Fragment>
    );
  }
}
